// Optum/Abyss Design System Theme

export const optumTheme = {
  colors: {
    // Primary Optum colors
    optumBlue: '#002677',
    optumBlueLight: '#0047bb',
    optumOrange: '#ff612b',
    
    // Accent colors
    accentBlue: '#0091da',
    accentTeal: '#00a9ce',
    
    // Semantic colors
    success: '#52bd94',
    warning: '#ff9e1b',
    error: '#e74c3c',
    
    // Text colors
    textPrimary: '#2c3e50',
    textSecondary: '#5a6c7d',
    textMuted: '#8899a6',
    
    // Background colors
    bgLight: '#f8f9fa',
    bgWhite: '#ffffff',
    bgCard: '#ffffff',
    
    // Border colors
    border: '#e1e8ed',
    borderLight: '#eef2f6',
    
    // Health score colors
    healthScore: {
      excellent: '#00b894',
      good: '#52bd94',
      warning: '#ff9e1b',
      poor: '#e74c3c',
      critical: '#c0392b',
    },
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '48px',
  },
  
  borderRadius: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
  
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',
    md: '0 4px 12px rgba(0, 0, 0, 0.1)',
    lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
  },
  
  typography: {
    fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif",
    fontSize: {
      xs: '12px',
      sm: '14px',
      md: '16px',
      lg: '18px',
      xl: '20px',
      xxl: '24px',
      xxxl: '32px',
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
  },
  
  // Health score colors
  healthScore: {
    excellent: '#10b981',
    good: '#52bd94',
    warning: '#ff9e1b',
    poor: '#f97316',
    critical: '#e74c3c',
  },
};

export type Theme = typeof optumTheme;
